import { NgModule } from '@angular/core';
import { SharedModule } from '@shared/shared.module';
import { AuthRoutingModule } from './auth-routing.module';
import { LoginComponent } from './login/login.component';
import { ResetPasswordComponent } from './reset-password/reset-password.component';
import { NewPasswordComponent } from './new-password/new-password.component';
import { ConfirmSmsComponent } from './confirm-sms/confirm-sms.component';
import { NewPhoneComponent } from './new-phone/new-phone.component';



@NgModule({
  declarations: [
    LoginComponent,
    ResetPasswordComponent,
    NewPasswordComponent,
    ConfirmSmsComponent,
    NewPhoneComponent
  ],
  imports: [
    AuthRoutingModule,
    SharedModule,
  ]
})
export class AuthModule { }
